
import React, { useState } from 'react';
import './border.css';

const Border = ({ title, src, text }) => {
  const [isVariant, setIsVariant] = useState(false);

  return (
    <>

      <div className="border_container">
        <img src={src} alt="icon" className="border_img" />
        <div className="border_title">{title}</div>
        <div className="border_text">{text}</div>
      </div>
    </>

  )
}

export default Border;